import type { EChartsCoreOption } from 'echarts/core';
import moment from 'moment-timezone';

import type { ReportsCategoryAxisOptions } from '@core/reports-types';

const format = (
  date: moment.Moment,
  prevDate: moment.Moment,
  singleTickAxis: boolean,
  index: number,
) => {
  if (singleTickAxis) {
    return `Q${date.quarter()}\n${date.year()}`;
  }

  if (index === 0 || (index > 0 && prevDate.year() !== date.year())) {
    return `{level1|Q${date.quarter()}\n${date.year()}}`;
  }

  return `Q${date.quarter()}`;
};

const formatterFactory = (singleTickAxis: boolean) => {
  let prevDate: moment.Moment;
  return (value: number, index: number) => {
    const date = moment(value);
    const result = format(date, prevDate, singleTickAxis, index);
    prevDate = date;
    return result;
  };
};

export const quarterly = (
  ticksCount: number,
): { xAxis: ReportsCategoryAxisOptions; media?: EChartsCoreOption['media'] } => {
  const boundaryGap = ['10%', '10%'];
  const singleTickAxis = ticksCount === 1;

  return {
    xAxis: {
      type: 'category',
      boundaryGap,
      showMinLabel: false,
      showMaxLabel: false,
      axisTick: {
        alignWithLabel: true,
      },
      axisLabel: {
        interval: 'auto',
        fontSize: 12,
        rich: {
          primary: {
            top: 30,
            fontWeight: 'normal',
          },
          level1: {
            fontWeight: 'bold',
          },
        },
        formatter: formatterFactory(singleTickAxis),
      },
    },
  };
};
